export default "__VITE_ASSET__DBmgiNlX__"